

// import { IndexClient } from "candb-client-typescript/dist/IndexClient";

import { /*Actor,*/ randomNumber } from "@dfinity/agent";

// import * as agent_1 from "@dfinity/agent";
import * as createActor_1 from "candb-client-typescript/dist/createActor";
import MailAddressUtils from "../utils/MailAddressUtils";
import { MailEncryptionType } from "../utils/Types";
import { mailAddressDomain, mailAddressSubdomain, mailAddressSuffix, mailAddressToSignalIdentity, signalIdentityToMailAddress } from "../common/constants";
import { v4 as uuidv4 } from 'uuid';

// import { idlFactory as IndexCanisterIDL } from "../../../declarations/pleximail_index/index";
// import { idlFactory as PlexiMailServiceCanisterIDL } from "../../../declarations/pleximail_backend/index";
// import { IndexCanister } from "../../../declarations/pleximail_index/pleximail_index.did";
// import { PlexiMailService } from "../../../declarations/pleximail_backend/pleximail_backend.did";


// import * as vetkd from "ic-vetkd-utils";
import { Actor } from "@dfinity/agent";
import { Principal } from "@dfinity/principal";
import { ServerError } from "../common/errors";
import PaymentStrings from "../components/payment/PaymentStrings";
import { DerivedPublicKey, TransportSecretKey, EncryptedVetKey } from "@dfinity/vetkeys";
import {DateUtils} from "../utils/DateUtils"
import { ethers } from 'ethers';

// import { idlFactory as IndexCanisterIDL } from "../../../declarations/pleximail_index/index";
// import { idlFactory as PlexiMailServiceCanisterIDL } from "../../../declarations/pleximail_backend/index";
// import { IndexCanister } from "../../../declarations/pleximail_index/pleximail_index.did";
// import { PlexiMailService } from "../../../declarations/pleximail_backend/pleximail_backend.did";

// const DIRECT_PAYMENT_SERVER_BASE_URL = "http://127.0.0.1:3010";
const DIRECT_PAYMENT_SERVER_BASE_URL = "https://www.ai-fi.cc";


const hex_decode = (hexString) =>
    Uint8Array.from(hexString.match(/.{1,2}/g).map((byte) => parseInt(byte, 16)));
const hex_encode = (bytes) =>
    bytes.reduce((str, byte) => str + byte.toString(16).padStart(2, '0'), '');

// const vkd = vetkd;

// vkd.default();
export class PlexiMailService {

    static CRYPTON_PREFIX = 'crypton.';
    static MAILLIST_PREFIX = 'maillist.';
    static ENVELOPE_PREFIX = "envelope.";
    static USER_PREFIX = 'user.';
    static DEVICE_PREFIX = 'devices.';

    #indexClient = null;
    #plexiMailServiceClient = null;
    #group = null;
    #principal = null;
    actorCacheMap = {
        
    };
    #vetkeysCanister = null;
    #isRegistered = false;
    #canisterIBelong = null;
    #enterpriseResourceCanister = null;
    #clientSecure = null;
    #cache = {};
    forceRefresh = false;

    constructor(principal, group, indexClient, plexiMailServiceClient) {
        this.#principal = principal;
        this.#group = group;

        this.#indexClient = indexClient;

        this.#plexiMailServiceClient = plexiMailServiceClient;
        
    }

    getPrincipal() {
        return this.#principal;
    }


    async saveBusinessEntity(entity) {
        const newEntity = {
            name: entity.name,
            address: entity.address || '',
            tel: entity.tel || '',
            tex: entity.tex || '',
            email: entity.email || '',
            zip: entity.zip || '',
            domain: entity.domain,
            capacity: entity.capacity,
            features: entity.features || ['mail', 'contract', 'multi-address', 'contacts', 'notes']
        };
        const success = await this.#indexClient.indexCanisterActor.saveBusinessEntity(entity.domain, newEntity);
        return success;
    }
    
    async getBusinessEntity(domain) {
        const entity = await this.#indexClient.indexCanisterActor.getBusinessEntity(domain);
        return entity;
    }
    async createCanisterByGroupIfNeeded() {
        const result = await this.#indexClient.indexCanisterActor.createPlexiMailServiceCanisterByGroup(this.#group);
        return result;
    }
    async beginVerifyingDomain(domain) {
        const result = await this.#indexClient.indexCanisterActor.beginVerifyingDomain(domain);
        return result;
    }
    async verifyDomain(domain) {
        const result = await this.#indexClient.indexCanisterActor.verifyDomain(domain);
        return result;
    }

    async createPaymentSession(domain, plan='business') {
        const result = await this.#indexClient.indexCanisterActor.createPaymentSession(domain, plan);
        return result;
    }
    
    async retrieveCheckoutSession(domain) {
        const result = await this.#indexClient.indexCanisterActor.retrieveCheckoutSession(domain);
        return result;
    }

    async subscribe(domain) {
        const result = await this.#indexClient.indexCanisterActor.subscribe(domain);
        if (result.code === 0) {
            this.#canisterIBelong = result.data;
        }
        return result;
    }

    async getContacts(domain, path) {
        
        let pk = `group#${domain}`;

        if (!this.#enterpriseResourceCanister) {
            const canisterIds = await this.#indexClient.getCanistersForPK(pk, false);
            if (!canisterIds || canisterIds.length === 0) {
                // throw new Error('Canister not found in this partition');
                return null;
            }
            const canisterActor = (0, createActor_1.createActor)(Object.assign(Object.assign({}, this.#plexiMailServiceClient.actorOptions), { canisterId: canisterIds[0] }));
            this.#enterpriseResourceCanister = canisterActor;
        }


        const result = await this.#enterpriseResourceCanister.getContacts(path, false);
        return result;
    }

    async addContactNode(domain, path, node) {
        
        let pk = `group#${domain}`;

        if (!this.#enterpriseResourceCanister) {
            const canisterIds = await this.#indexClient.getCanistersForPK(pk, false);
            if (!canisterIds || canisterIds.length === 0) {
                // throw new Error('Canister not found in this partition');
                return null;
            }
            const canisterActor = (0, createActor_1.createActor)(Object.assign(Object.assign({}, this.#plexiMailServiceClient.actorOptions), { canisterId: canisterIds[0] }));
            this.#enterpriseResourceCanister = canisterActor;
        }
        const result = await this.#enterpriseResourceCanister.addContactNode(path, node);
        return result;
    }

    async deleteContactNode(domain, path) {

        
        let pk = `group#${domain}`;

        if (!this.#enterpriseResourceCanister) {
            const canisterIds = await this.#indexClient.getCanistersForPK(pk, false);
            if (!canisterIds || canisterIds.length === 0) {
                // throw new Error('Canister not found in this partition');
                return null;
            }
            const canisterActor = (0, createActor_1.createActor)(Object.assign(Object.assign({}, this.#plexiMailServiceClient.actorOptions), { canisterId: canisterIds[0] }));
            this.#enterpriseResourceCanister = canisterActor;
        }
        
        const result = await this.#enterpriseResourceCanister.deleteContactNode(path);
        return result;
    }
    

    // async update(pk, sk, updateFn) {
    //     let canisterIds = await this.#indexClient.getCanistersForPK(pk, true);
    //     // Can fail here if the incorrect primary key is used or if the index canister does not permit access to the PK for the calling principal
    //     if (canisterIds.length === 0) {
    //         canisterIds = await this.#indexClient.getCanistersForPK(pk, true);
    //         if (canisterIds.length === 0) {
    //             throw new Error("Unable to update this record. Please ensure the entity you are trying to update has the appropriate primary key (PK)");
    //         }
    //     }

    //     // array to store error multiple messages that could happen when calling multiple canisters
    //     const errors = [];
    //     // for update calls, never use the cache
    //     const matchingSK = (await this.query(pk, (a) => a.skExists(sk))).reduce((acc, settledResult, index) => {
    //         const canisterId = canisterIds[index];
    //         if (settledResult.status === "rejected") {
    //             errors.push(`A call to canister: ${canisterId} was rejected due to ${settledResult.reason}`);
    //             return acc;
    //         }
    //         if (settledResult.value === true)
    //             return acc.concat(canisterId);
    //         return acc;
    //     }, []);
    //     if (matchingSK.length > 1) {
    //         errors.push(`Uniqueness constraint violation error. Found multiple occurences of the same PK + SK combination: ${matchingSK}`);
    //     }
    //     // If any errors exist, throw here before an update is made
    //     if (errors.length > 0) {
    //         throw new Error(errors.toString());
    //     }
    //     // the canister that the update call will be made to
    //     const canisterToMakeUpdateCallTo = matchingSK.length === 0
    //         ? // no matching sks meaning that the pk + sk was combination not found, so insert into most recent canister
    //             canisterIds[canisterIds.length - 1]
    //         : // otherwise insert into the first (and only) matching canisterId
    //             matchingSK[0];
    //     const updateCanisterActor = (0, createActor_1.createActor)(Object.assign(Object.assign({}, this.actorOptions), { canisterId: canisterToMakeUpdateCallTo }));
    //     return updateFn(updateCanisterActor);
    // }

    async query(queryFn) {
        let pk = `group#${this.#group}`;
        let results = await this.#plexiMailServiceClient.query(
            pk,
            queryFn,
            true
        );
        return results;
    }

    async randomQueryOne(queryFn) {
        let pk = `group#${this.#group}`;


        const canisterIds = await this.#indexClient.getCanistersForPK(pk, true);
        if (!canisterIds || canisterIds.length === 0) {
            throw new Error('Canister not found in this partition');
        }

        const canisterToMakeQueryCallTo = canisterIds[randomNumber() % canisterIds.length];

        const canisterActor = (0, createActor_1.createActor)(Object.assign(Object.assign({}, this.#plexiMailServiceClient.actorOptions), { canisterId: canisterToMakeQueryCallTo }));
        return queryFn(canisterActor);
    }

    async queryOne(queryFn) {
        const results = await this.query(queryFn);

        for (let result of results) {
            // handle settled result if fulfilled
            if (result.status === "fulfilled" && result.value) {
                // handle candid returned optional type (string[] or string)
                return Array.isArray(result.value) ? result.value[0] : result.value
            } 
        }
        return null;
    }
    async queryList(queryFn) {
        const results = await this.query(queryFn);

        var array = [];
        for (let result of results) {
            // handle settled result if fulfilled
            if (result.status === "fulfilled" && result.value) {
                if (Array.isArray(result.value)) {
                    array = array.concat(array, result.value);
                } else {
                    array.push(result.value);
                }
            } 
        }

        return array;
    }
    

    async update(sk, updateFn) {
        let pk = `group#${this.#group}`;
        let result = await this.#plexiMailServiceClient.update(
            pk,
            sk,
            updateFn
        );
        return result;
    }
    getCanisterIdIBelongTo() {
      const myAddress = (window.appConfig.recentActiveAccount + mailAddressSuffix()).toLowerCase();

      const actor = this.actorCacheMap[myAddress];
      if (!actor) {
        return null;
      }
      if (actor.canisterId) {
        return actor.canisterId;
      }
      const metadata = actor[Symbol.for("ic-agent-metadata")];
      if (metadata && metadata.config && metadata.config.canisterId) {
        return metadata.config.canisterId
      }
      return null;
    }
    async getSenderCanisterId(address) {
      const actor = await this.getCanisterByMailAddress(address);
      if (!actor) {
        return null;
      }
      if (actor.canisterId) {
        return actor.canisterId;
      }
      const metadata = actor[Symbol.for("ic-agent-metadata")];
      if (metadata && metadata.config && metadata.config.canisterId) {
        return metadata.config.canisterId
      }
      return null;
    }

    async getEnterpriseCanisterByMailAddress(address) {

      address = address.toLowerCase();

      const addr = MailAddressUtils.parseOneAddress(address);
      const signalIdentity = mailAddressToSignalIdentity(address);
        // const signalAccount = mailAddressToSignalIdentity(address);
        const actor = this.actorCacheMap[address];
        if (actor) {
            return actor;
        }

        const subDomain = mailAddressSubdomain();
        let domain = addr.domain;
        if (domain.startsWith(subDomain)) {
            domain = domain.substring(subDomain.length);
        }
        
        let pk = `group#${domain}`;

        const canisterIds = await this.#indexClient.getCanistersForPK(pk, false);
        if (!canisterIds || canisterIds.length === 0) {
            // throw new Error('Canister not found in this partition');
            return null;
        }
        for(const canisterId of canisterIds) {

            const canisterActor = (0, createActor_1.createActor)(Object.assign(Object.assign({}, this.#plexiMailServiceClient.actorOptions), { canisterId: canisterId }));
            const exists = await canisterActor.isPendingUserExists(signalIdentity);
            if (exists) {
                canisterActor.canisterId = canisterId;
                this.actorCacheMap[address] = canisterActor;
                return canisterActor;
            }
        }
        return null;
    }

    async getVetkeysCanister(domain) {
        if (this.#vetkeysCanister) {
            return this.#vetkeysCanister;
        }

        let pk = `group#${domain}`;
        const canisterIds = await this.#indexClient.getCanistersForPK(pk, false);
        if (!canisterIds || canisterIds.length === 0) {
            // throw new Error('Canister not found in this partition');
            return null;
        }
        const canisterId = canisterIds[0];
        const canisterActor = (0, createActor_1.createActor)(Object.assign(Object.assign({}, this.#plexiMailServiceClient.actorOptions), { canisterId: canisterId }));
        this.#vetkeysCanister = canisterActor;
        return canisterActor;
    }
    async getCanisterForRequestingWeb3Storage(address) {

      address = address.toLowerCase();

      const addr = MailAddressUtils.parseOneAddress(address);
      const signalIdentity = mailAddressToSignalIdentity(address);
        const actor = this.actorCacheMap[address];
        if (actor) {
            return actor;
        }
        
        const subDomain = mailAddressSubdomain();
        let domain = addr.domain;
        if (domain.startsWith(subDomain)) {
            domain = domain.substring(subDomain.length);
        }
        
        let pk = `group#${domain}`;

        const canisterIds = await this.#indexClient.getCanistersForPK(pk, false);
        if (!canisterIds || canisterIds.length === 0) {
            // throw new Error('Canister not found in this partition');
            return null;
        }
        for(const canisterId of canisterIds) {

            const canisterActor = (0, createActor_1.createActor)(Object.assign(Object.assign({}, this.#plexiMailServiceClient.actorOptions), { canisterId: canisterId }));
            const exists = await canisterActor.userExists(signalIdentity);
            if (exists) {
                canisterActor.canisterId = canisterId;
                this.actorCacheMap[address] = canisterActor;
                return canisterActor;
            }
        }


        const canisterId = canisterIds[canisterIds.length - 1];
        const canisterActor = (0, createActor_1.createActor)(Object.assign(Object.assign({}, this.#plexiMailServiceClient.actorOptions), { canisterId: canisterId }));
        canisterActor.canisterId = canisterId;
        return canisterActor;
    }

    async getCanisterByMailAddress(address, withDefault=false) {

      address = address.toLowerCase();
      const addr = MailAddressUtils.parseOneAddress(address);
      const signalIdentity = mailAddressToSignalIdentity(address);

        const actor = this.actorCacheMap[address];
        if (actor) {
            return actor;
        }
        
        const subDomain = mailAddressSubdomain();
        let domain = addr.domain;
        if (domain.startsWith(subDomain)) {
            domain = domain.substring(subDomain.length);
        }
        
        let pk = `group#${domain}`;

        const canisterIds = await this.#indexClient.getCanistersForPK(pk, false);
        if (!canisterIds || canisterIds.length === 0) {
            // throw new Error('Canister not found in this partition');
            return null;
        }
        for(const canisterId of canisterIds) {

            const canisterActor = (0, createActor_1.createActor)(Object.assign(Object.assign({}, this.#plexiMailServiceClient.actorOptions), { canisterId: canisterId }));
            const exists = await canisterActor.userExists(signalIdentity);
            if (exists) {
                canisterActor.canisterId = canisterId;
                this.actorCacheMap[address] = canisterActor;
                return canisterActor;
            }
        }
        if (withDefault) {

            const canisterId = canisterIds[canisterIds.length - 1];
            const canisterActor = (0, createActor_1.createActor)(Object.assign(Object.assign({}, this.#plexiMailServiceClient.actorOptions), { canisterId: canisterId }));
            canisterActor.canisterId = canisterId;
            // this.actorCacheMap[address] = canisterActor;
            return canisterActor;
        }
        return null;
        // throw new Error('User not found');

        // const result = await this.queryList(async(actor) => {
        //     const exists = await actor.userExists(address);
        //     if (exists) {
        //         const canisterId = Actor.canisterIdOf(actor);
        //         console.log("canister id: ", canisterId.toText());
        //         return canisterId;
        //     }
        // });
        // return result;
    }

    async isKeyExists(sk){
        const result = await this.queryList((actor) => {
            return actor.skExists(sk);
        });
        return result;
    }


    async dbInsight() {
        const result = await this.queryList((actor) => {
            return actor.allEntries();
        });
        return result;
    }
    async p2c(p) {

        let pk = `group#${this.#group}`;


        const canisterIds = await this.#indexClient.getCanistersForPK(pk, false);
        if (!canisterIds || canisterIds.length === 0) {
            throw new Error('Canister not found in this partition');
        }

        const canisterToMakeQueryCallTo = canisterIds[randomNumber() % canisterIds.length];

        const canisterActor = (0, createActor_1.createActor)(Object.assign(Object.assign({}, this.#plexiMailServiceClient.actorOptions), { canisterId: canisterToMakeQueryCallTo }));
        const result = await canisterActor.p2c(p);
        return result;
    }
    async c2p(c) {

        let pk = `group#${this.#group}`;


        const canisterIds = await this.#indexClient.getCanistersForPK(pk, false);
        if (!canisterIds || canisterIds.length === 0) {
            throw new Error('Canister not found in this partition');
        }

        const canisterToMakeQueryCallTo = canisterIds[randomNumber() % canisterIds.length];

        const canisterActor = (0, createActor_1.createActor)(Object.assign(Object.assign({}, this.#plexiMailServiceClient.actorOptions), { canisterId: canisterToMakeQueryCallTo }));
        const result = await canisterActor.c2p(c);
        return result;
    }
    

    async randomVerificationCode(length, simple=true) {
        // const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        const chars = simple ? '123456789abcdefghijkmnpqrstuvwxyz' : 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*_-=+';
        // const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*_-=+";
        let password = "";
        for (let i = 0; i < length; i++) {
            password += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return password;
    };

    async addUser(address) {
        address = address.toLowerCase();
        const signalIdentity = mailAddressToSignalIdentity(address);
        const canisterActor = await this.getCanisterByMailAddress(address, true);
        const code = await this.randomVerificationCode(16, false);
        const res = await canisterActor.addUser(signalIdentity, code);
        // res.data = canisterActor.canisterId;
        
        return [res, canisterActor.canisterId];
    };

    async  getPendingUser(address) {
        address = address.toLowerCase();

        const canisterActor = await this.getEnterpriseCanisterByMailAddress(address);

        const signalIdentity = mailAddressToSignalIdentity(address)
        const code = await canisterActor.getPendingUser(signalIdentity);
        return (code && code.length === 1) ? code[0] : null;
    };
    
    async activateUser(address) {
        address = address.toLowerCase();
        const signalIdentity = mailAddressToSignalIdentity(address);
        const code = await this.getPendingUser(address);
        if (!code ) {
            throw new Error('Access Denied');
        }
        const web3 = window.web3Helper.web3;

        const canisterActor = await this.getEnterpriseCanisterByMailAddress(address);
        const signature = await web3.eth.personal.sign(
            code,
            address,
            "--sign-the-message-silently--"
        );
        const res = await canisterActor.activateUser(signature, signalIdentity);
        return res ;
    }

    async deleteCanisters() {

        let pk = `group#${this.#group}`;

        const canisters = await this.#indexClient.indexCanisterActor.getCanistersByPK(pk);
        for(const canister of canisters) {
            await this.#indexClient.indexCanisterActor.deleteServiceCanisterById(pk, canister);
        }
    }

    async getCrypton(name) {
        const cid = await this.queryOne((actor) => {
            return actor.getCrypton(name)
        });
        return cid;
    }
    
    async saveCrypton(form) {
        const sk = PlexiMailService.CRYPTON_PREFIX + this.#principal + '.' + form.name;
        const result = await this.update(sk, (actor) => {
            return actor.saveCrypton(form);
        });
        return result;
    }

    async deleteCrypton(name) {
        
        const sk = PlexiMailService.CRYPTON_PREFIX + this.#principal + '.' + name;
        const result = await this.update(sk, (actor) => {
            return actor.deleteCrypton(name);
        });
        return result;
    }

    get alreadyRegistered() {
        return this.#isRegistered;
    }
    
    async isRegistered() {

        this.#isRegistered = false;
        const results = await this.isKeyExists(PlexiMailService.USER_PREFIX + 'users.' + this.#principal);
        if (!results || results.length === 0) {
            return false;
        }

        for(const result of results) {
            if (result) {
                this.#isRegistered = true;
                return result;
            }
        }

        return false;
        // const reg = await this.queryOne((actor) => {
        //     return actor.isRegistered();
        // });
        // return reg;
    }
    async closeAccount() {
        const actor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
        if (!actor) {
            return false;
        }

        try {
            const res = await actor.closeAccount();
            return res;
        } catch (e) {
            console.error(e);
            return false;
        }
    }
    
    async getMailList(deviceId) {
        const mailList = await this.queryOne((actor) => {
            return actor.getMailList(deviceId);
        });
        return mailList;
    }

    async saveMailList(deviceId, cid) {
        const self = this;
        if (window.appConfig.recentActiveAccount && window.appConfig.recentActiveAccount.length > 0) {
            const actor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
            if (actor) {
                const success = await actor.saveMailList(deviceId, cid);
                return success;
            }
        }

        const sk = PlexiMailService.MAILLIST_PREFIX + this.#principal + '.' + deviceId;
        const success = await this.update(sk, (actor) => {
            /*
            if (window.appConfig.recentActiveAccount && window.appConfig.recentActiveAccount.length > 0) {
              const metadata = actor[Symbol.for("ic-agent-metadata")];
              if (metadata && metadata.config && metadata.config.canisterId) {
                actor.canisterId=metadata.config.canisterId.toString()
              }
              self.actorCacheMap[window.appConfig.recentActiveAccount + mailAddressSuffix()] = actor;
            }*/
            return actor.saveMailList(deviceId, cid);
        });
        return success;
    }

    async deleteMailList(deviceId) {
        const sk = PlexiMailService.MAILLIST_PREFIX + this.#principal + '.' + deviceId;
        const result = await this.update(sk, (actor) => {
            return actor.deleteMailList(deviceId);
        });
        return result;
    }

    async finishContract(moderator, messageId) {

        const canisterActor = await this.getCanisterByMailAddress(moderator);
        if (!canisterActor) {
            throw new Error("Canister not found");
        }
        const success = await canisterActor.finishContract(messageId);
        if (!success) {
            throw new Error("Failed to finish a contract " + messageId);
        }
    }

    async sendMail(appMessage) {
        // appMessage.sender.account 
        const sk = PlexiMailService.ENVELOPE_PREFIX + this.#principal + '.' + appMessage.sender.deviceId;
        const success = await this.update(sk, (actor) => {
            return actor.sendMail(appMessage);
        });
        return success;
    }

    async sendMailsV1(appMessage) {
        const {sender, envelopes} = appMessage.notify;
        const envelope = envelopes[0];
        console.log('sendMails: ', envelope);

        /*
        signalEnvelope = {
            am: 0,
            ct: [],
            to: [],
            mid: message.mid,
            ref: [],
            uid: message.uid,
            expires: 0,
            from: message.from,
            salt: [],
            type: message.type,
            encryptedHeader: encryptedHeaderJSONString, // sig
            address: [myAddress],
            deviceId: [myDeviceId],
            signal: [signal],
            sendDate: header.sendDate,
        };
        */

        if (envelope.type === MailEncryptionType.plaintext) {
            throw new Error('no longer supported');
        } else if (envelope.type === MailEncryptionType.password) {
            
            const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());

            // const canisterActor = await this.getCanisterByMailAddress(to);
            let result = await canisterActor.sendMail(appMessage);
            if (!result.sentFeedback && (result.code !== 0 || result.error)) {
                if (result.error) {
                    throw result.error;
                }
                throw result;
            }

            /*
            const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
            const results = [];
            for(const to of envelope.to[0]) {
                
                const appMessage = {
                    notify: {
                        sender,
                        envelopes: [{
                            ...envelope,
                            to: [[to]]
                        }]
                    }
                };

                // const canisterActor = await this.getCanisterByMailAddress(to);
                let result = await canisterActor.sendMail(appMessage);
                results.push(result);
            }

            console.log(results);
            */

        } else if (envelope.type === MailEncryptionType.signal) {

            
            let groups = null;

            for(const account of envelope.signal[0].accounts) {
                if (!groups) {
                    groups = {};
                }
                const address = signalIdentityToMailAddress(account.account);
                const canisterActor = await this.getCanisterByMailAddress(address);
                // const canisterId = canisterActor[Symbol.for('ic-agent-metadata')].config.canisterId.toString()
                if (groups[canisterActor.canisterId]) {
                    groups[canisterActor.canisterId].signal.push(account)
                } else {
                    groups[canisterActor.canisterId] = {
                        canisterActor: canisterActor,
                        signal: [account],
                        to: []
                    }
                };
            }

            
            if (groups) {
                for(const key in groups) {
                    const group = groups[key];

                    const appMessage = {
                        notify: {
                            sender,
                            envelopes: [{
                                ...envelope,
                                signal: [{...envelope.signal[0], accounts: group.signal}]
                            }]
                        }
                    };

                    // const canisterActor = await this.getCanisterByMailAddress(account.account + mailAddressSuffix());
                    const result = await group.canisterActor.sendMail(appMessage);
                    if (!result.sentFeedback && result.code !== 0) {
                        throw result;
                    }
                }
            }

            /*
            for(const account of envelope.signal[0].accounts) {
                const appMessage = {
                    notify: {
                        sender,
                        envelopes: [{
                            ...envelope,
                            signal: [{...envelope.signal[0], accounts: [account]}]
                        }]
                    }
                };
                const canisterActor = await this.getCanisterByMailAddress(account.account + mailAddressSuffix());
                const result = await canisterActor.sendMail(appMessage);
                if (!result.sentFeedback && result.code !== 0) {
                    throw result;
                }
            }
            */
        } else if (envelope.type === MailEncryptionType.mixed) {
            

            let groups = null;

            for(const account of envelope.signal[0].accounts) {
                if (!groups) {
                    groups = {};
                }
                const address = signalIdentityToMailAddress(account.account);

                const canisterActor = await this.getCanisterByMailAddress(address);
                if (groups[canisterActor.canisterId]) {
                    groups[canisterActor.canisterId].signal.push(account)
                } else {
                    groups[canisterActor.canisterId] = {
                        canisterActor: canisterActor,
                        signal: [account],
                        to: []
                    }
                };
            }
            if (!groups && envelope.to[0].length > 0) {
                groups = {}
            }
            const myCanisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
            if (groups[myCanisterActor.canisterId]) {
                groups[myCanisterActor.canisterId].to = envelope.to[0];
            } else {
                groups[myCanisterActor.canisterId] = {
                    canisterActor: myCanisterActor,
                    signal: [],
                    to: envelope.to[0]
                }
            }
            const results = [];
            if (groups) {
                for(const key in groups) {
                    const group = groups[key];

                    const appMessage = {
                        notify: {
                            sender,
                            envelopes: [{
                                ...envelope,
                                to: [group.to],
                                signal: [{...envelope.signal[0], accounts: group.signal}]
                            }]
                        }
                    };
                    console.log('sendMail: #group: ', group, ', message: ', appMessage);
                    // const canisterActor = await this.getCanisterByMailAddress(account.account + mailAddressSuffix());
                    const result = await group.canisterActor.sendMail(appMessage);
                    if (!result.sentFeedback && result.code !== 0) {
                        throw result;
                    }
                    results.push(result);
                }
            }
            /*
            for(const account of envelope.signal[0].accounts) {

                const appMessage = {
                    notify: {
                        sender,
                        envelopes: [{
                            ...envelope,
                            to: [],
                            signal: [{...envelope.signal[0], accounts: [account]}]
                        }]
                    }
                };
                console.log('sendMails #appMessage: ', appMessage);
                const canisterActor = await this.getCanisterByMailAddress(account.account + mailAddressSuffix());
                const result = await canisterActor.sendMail(appMessage);
                if (!result.sentFeedback && result.code !== 0) {
                    throw result;
                }
            }

            const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
            const results = [];
            for(const to of envelope.to[0]) {
                
                const appMessage = {
                    notify: {
                        sender,
                        envelopes: [{
                            ...envelope,
                            signal: [],
                            to: [[to]]
                        }]
                    }
                };

                // const canisterActor = await this.getCanisterByMailAddress(to);
                let result = await canisterActor.sendMail(appMessage);
                results.push(result);
            }
            */
        } else {
            throw new Error('Invalid message type');
        }
        
        // appMessage.sender.account 
        // const sk = PlexiMailService.ENVELOPE_PREFIX + this.#principal + '.' + appMessage.sender.deviceId;
        // const success = await this.update(sk, (actor) => {
        //     return actor.sendMail(appMessage);
        // });
        return true;
    }


    async sendNotifications(notifications) {
        const filteredNotifications = []
        for(const notification of notifications) {
            const filteredNotification = {...notification}
            filteredNotification.envelopes = notification.envelopes.filter(envelope => {
                return envelope.type === 'reg'
            })
            filteredNotifications.push(filteredNotification);
        }
        
        const clientSecure = await this.getClientSecure();

        let url = `${DIRECT_PAYMENT_SERVER_BASE_URL}/sendgird/client-send`;
        const resp = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + clientSecure
            },
            body: JSON.stringify(notifications),
        }).then(resp => {
            if (resp.status >= 200 || resp.status < 300) {
                return {code: 0, msg: "success"};
            }
            return {code: (resp.status > 0 ? -resp.status : resp.status), msg: resp.statusText};
        });
        return resp;
    }

    async sendMailV2(appMessage) {
        // appMessage.sender.account 
        const sk = PlexiMailService.ENVELOPE_PREFIX + this.#principal + '.' + appMessage.sender.deviceId;
        const success = await this.update(sk, (actor) => {
            return actor.sendMail(appMessage);
        });
        return success;
    }

    async sendMailsV2(appMessage) {
        const {sender, envelopes} = appMessage.notify;
        const envelope = envelopes[0];
        console.log('sendMails: ', envelope);

        /*
        signalEnvelope = {
            am: 0,
            ct: [],
            to: [],
            mid: message.mid,
            ref: [],
            uid: message.uid,
            expires: 0,
            from: message.from,
            salt: [],
            type: message.type,
            encryptedHeader: encryptedHeaderJSONString, // sig
            address: [myAddress],
            deviceId: [myDeviceId],
            signal: [signal],
            sendDate: header.sendDate,
        };
        */

        if (envelope.type === MailEncryptionType.plaintext) {
            throw new Error('no longer supported');
        } else if (envelope.type === MailEncryptionType.password) {
            
            const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());

            // const canisterActor = await this.getCanisterByMailAddress(to);
            let result = await canisterActor.sendMailV2(appMessage);
            if ((!result.sentFeedback && !result.sentFeedbackV2) && (result.code !== 0 || result.error)) {
                if (result.error) {
                    throw result.error;
                }
                throw result;
            }

            if (result.sentFeedbackV2) {
                await this.sendNotifications([result.sentFeedbackV2])
            }

        } else if (envelope.type === MailEncryptionType.signal) {

            
            let groups = null;

            for(const account of envelope.signal[0].accounts) {
                if (!groups) {
                    groups = {};
                }
                const address = signalIdentityToMailAddress(account.account);
                const canisterActor = await this.getCanisterByMailAddress(address);
                // const canisterId = canisterActor[Symbol.for('ic-agent-metadata')].config.canisterId.toString()
                if (groups[canisterActor.canisterId]) {
                    groups[canisterActor.canisterId].signal.push(account)
                } else {
                    groups[canisterActor.canisterId] = {
                        canisterActor: canisterActor,
                        signal: [account],
                        to: []
                    }
                };
            }

            
            if (groups) {
                for(const key in groups) {
                    const group = groups[key];

                    const appMessage = {
                        notify: {
                            sender,
                            envelopes: [{
                                ...envelope,
                                signal: [{...envelope.signal[0], accounts: group.signal}]
                            }]
                        }
                    };

                    // const canisterActor = await this.getCanisterByMailAddress(account.account + mailAddressSuffix());
                    const result = await group.canisterActor.sendMailV2(appMessage);
                    if ((!result.sentFeedback && !result.sentFeedbackV2) && result.code !== 0) {
                        throw result;
                    }
                }
            }
        } else if (envelope.type === MailEncryptionType.mixed) {
            

            let groups = null;

            for(const account of envelope.signal[0].accounts) {
                if (!groups) {
                    groups = {};
                }
                const address = signalIdentityToMailAddress(account.account);

                const canisterActor = await this.getCanisterByMailAddress(address);
                if (groups[canisterActor.canisterId]) {
                    groups[canisterActor.canisterId].signal.push(account)
                } else {
                    groups[canisterActor.canisterId] = {
                        canisterActor: canisterActor,
                        signal: [account],
                        to: []
                    }
                };
            }
            if (!groups && envelope.to[0].length > 0) {
                groups = {}
            }
            const myCanisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
            if (groups[myCanisterActor.canisterId]) {
                groups[myCanisterActor.canisterId].to = envelope.to[0];
            } else {
                groups[myCanisterActor.canisterId] = {
                    canisterActor: myCanisterActor,
                    signal: [],
                    to: envelope.to[0]
                }
            }
            const results = [];
            const notifications = [];
            if (groups) {
                for(const key in groups) {
                    const group = groups[key];

                    const appMessage = {
                        notify: {
                            sender,
                            envelopes: [{
                                ...envelope,
                                to: [group.to],
                                signal: [{...envelope.signal[0], accounts: group.signal}]
                            }]
                        }
                    };
                    console.log('sendMail: #group: ', group, ', message: ', appMessage);
                    // const canisterActor = await this.getCanisterByMailAddress(account.account + mailAddressSuffix());
                    const result = await group.canisterActor.sendMailV2(appMessage);
                    if ((!result.sentFeedback && !result.sentFeedbackV2) && result.code !== 0) {
                        throw result;
                    }



                    if (result.sentFeedbackV2) {
                        notifications.push(result.sentFeedbackV2);
                    }
                    results.push(result);
                }
                if (notifications && notifications.length > 0) {
                    await this.sendNotifications(notifications);
                }
            }
        } else {
            throw new Error('Invalid message type');
        }
        
        // appMessage.sender.account 
        // const sk = PlexiMailService.ENVELOPE_PREFIX + this.#principal + '.' + appMessage.sender.deviceId;
        // const success = await this.update(sk, (actor) => {
        //     return actor.sendMail(appMessage);
        // });
        return true;
    }

    async sendMails(appMessage) {
        return this.sendMailsV2(appMessage);

        // if (localStorage.getItem('api.mail.version') === '2') {
        //     return this.sendMailsV2(appMessage);
        // } else {
        //     return this.sendMailsV1(appMessage);
        // }
    }

    mySessionID() {
        let sessionId = localStorage.getItem('mail.push.sessionId');
        if (!sessionId || sessionId === '') {
            sessionId = uuidv4();
            localStorage.setItem('mail.push.sessionId', sessionId);
        }
        return sessionId;
    }
    async kickOutOthers(myDeviceId) {
        const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
        if (!canisterActor) {
            throw new Error('user not found');
        }
        await canisterActor.kickOutOthers(myDeviceId, this.mySessionID());

    }

    async getMails(deviceId) {
        const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
        if (!canisterActor) {
            throw new Error('user not found');
        }
        const mails = await canisterActor.getMails(deviceId, this.mySessionID());
        return mails;

        // const mails = this.queryList((actor) => {
        //     return actor.getMails(deviceId);
        // });
        // return mails;
    }

    async removeMails(appMessage) {
        // appMessage.sender.address = this.#principal;
        const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
        if (!canisterActor) {
            throw new Error('user not found');
        }
        const result =  await canisterActor.removeMails(appMessage.copied || appMessage);
        if (result.error && result.error.code !== 0) {
            throw new Error(result.error.message);
        }
    }
    
    async getTimestamp() {
        return await this.randomQueryOne((actor) => {
            return actor.getTimestamp();
        });
    }

    async monitorAccount(address) {
        const emailAddress = signalIdentityToMailAddress(address);
        const canisterActor = await this.getCanisterByMailAddress(emailAddress);
        if (!canisterActor) {
            throw new Error('user not found');
        }
        const devices = await canisterActor.monitorAccount(address);
        return devices;

        // const devices = this.queryList((actor) => {
        //     return actor.monitorAccount(address);
        // });
        // return devices;
    }

    async queryAccount(address) {
        const emailAddress = signalIdentityToMailAddress(address);
        const canisterActor = await this.getCanisterByMailAddress(emailAddress);
        if (!canisterActor) {
            throw new Error('user not found');
        }
        const keyBundle = await canisterActor.queryAccount(address);
        return keyBundle;

        // const keyBundle = this.queryOne((actor) => {
        //     return actor.queryAccount(address);
        // });
        // return keyBundle;
    }

    async queryPrekeyCount(deviceId) {
        let address = window.appConfig.recentActiveAccount + mailAddressSuffix();
        const canisterActor = await this.getCanisterByMailAddress(address);
        if (!canisterActor) {
            throw new Error('user not found');
        }
        const countResult = await canisterActor.queryPrekeyCount(deviceId);
        return countResult;

        // const countResult = this.queryOne((actor) => {
        //     return actor.queryPrekeyCount(deviceId);
        // });
        // return countResult;
    }

    async registerDevice(encodedBundle) {
        const sk = PlexiMailService.USER_PREFIX + PlexiMailService.DEVICE_PREFIX + this.#principal; 
        
        const success = await this.update(sk, (actor) => {
            const src = localStorage.getItem("src")  || "self";
            encodedBundle.source = src;
            return actor.registerDevice(encodedBundle);
        });
        return success;
    }
    
    async retrievePreKey(address, deviceId) {
        const emailAddress = signalIdentityToMailAddress(address);
        const canisterActor = await this.getCanisterByMailAddress(emailAddress);
        if (!canisterActor) {
            throw new Error('user not found');
        }
        const preKey = await canisterActor.retrievePreKey(address, deviceId);
        return preKey;

        // const result = this.queryOne((actor) => {
        //     return actor.retrievePreKey(address, deviceId);
        // });
        // return result;
    }

    async retrievePiiInfo() {
        return null;
    }
    



    async saveContractArchive(deviceId, meta) {
        meta = JSON.stringify(meta);
        const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
        if (!canisterActor) {
            throw new Error('user not found');
        }
        let success = await canisterActor.saveContractArchive(deviceId, meta);
        return success;

    }

    async getContractArchives(deviceId) {
        const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
        if (!canisterActor) {
            throw new Error('user not found');
        }
        const archives = await canisterActor.getContractArchives(deviceId);
        const res = archives.map(a => {
            return JSON.parse(a);
        });
        return res;
    }

    async deleteContractArchives(deviceId) {
        const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
        if (!canisterActor) {
            throw new Error('user not found');
        }
        const success = await canisterActor.deleteContractArchives(deviceId);
        return success;
    }

    async addAddress(address, opt) {
        const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
        if (!canisterActor) {
            throw new Error('user not found');
        }
        address = mailAddressToSignalIdentity(address);
        const info = typeof opt === 'string' ? opt : JSON.stringify(opt);
        const success = await canisterActor.addAddress(address, info);
        return success;
    }

    async removeAddress(address) {
        const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
        if (!canisterActor) {
            throw new Error('user not found');
        }
        address = mailAddressToSignalIdentity(address);
        const success = await canisterActor.removeAddress(address);
        return success;
    }

    async getAddresses() {
        const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
        if (!canisterActor) {
            throw new Error('user not found');
        }
        const addresses = await canisterActor.getAddresses();
        if (addresses) {
            return addresses.map(addr => {
                return signalIdentityToMailAddress(addr);
            });
        }
        return addresses;

    }

    async getAddresseEntities() {
        const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
        if (!canisterActor) {
            throw new Error('user not found');
        }
        const addresses = await canisterActor.getAddresseEntities();
        if (addresses) {
            return addresses.map(addr => {
                const address = signalIdentityToMailAddress(addr[0]);
                const info = JSON.parse(addr[1]);
                return {address, ...info};
            });
        }
        return addresses;

    }



  async getPrincipalOfActor(actor) {
    let app_backend_principal = await Actor.agentOf(actor).getPrincipal();
    return app_backend_principal;
  }
  
//   async get_aes_256_gcm_key_v1() {

//     const canisterActor = await this.getVetkeysCanister(mailAddressDomain());

//     const seed = window.crypto.getRandomValues(new Uint8Array(32));
//     const tsk = new vetkd.TransportSecretKey(seed);
//     const ek_bytes_hex = await canisterActor.encrypted_symmetric_key_for_caller(tsk.public_key());
//     const pk_bytes_hex = await canisterActor.symmetric_key_verification_key();
//     const app_backend_principal = await this.getPrincipalOfActor(canisterActor);
//     return tsk.decrypt_and_hash(
//       hex_decode(ek_bytes_hex),
//       hex_decode(pk_bytes_hex),
//       app_backend_principal.toUint8Array(),
//       32,
//       new TextEncoder().encode("aes-256-gcm")
//     );
//   }
  
//   async get_aes_256_gcm_key_in_hex_v1() {
//     const canisterActor = await this.getVetkeysCanister(mailAddressDomain());


//     const seed = window.crypto.getRandomValues(new Uint8Array(32));
//     const tsk = new vetkd.TransportSecretKey(seed);
//     const ek_bytes_hex = await canisterActor.encrypted_symmetric_key_for_caller(tsk.public_key());
//     const pk_bytes_hex = await canisterActor.symmetric_key_verification_key();
//     const app_backend_principal = await this.getPrincipalOfActor(canisterActor);
//     const res = tsk.decrypt_and_hash(
//       hex_decode(ek_bytes_hex),
//       hex_decode(pk_bytes_hex),
//       app_backend_principal.toUint8Array(),
//       32,
//       new TextEncoder().encode("aes-256-gcm")
//     );
//     return hex_encode(res);
//   }

  async aes_gcm_encrypt(message, rawKey) {

    const iv = window.crypto.getRandomValues(new Uint8Array(12)); // 96-bits; unique per message
    const aes_key = await window.crypto.subtle.importKey("raw", rawKey, "AES-GCM", false, ["encrypt"]);
    const message_encoded = new TextEncoder().encode(message);
    const ciphertext_buffer = await window.crypto.subtle.encrypt(
      { name: "AES-GCM", iv: iv },
      aes_key,
      message_encoded
    );
    const ciphertext = new Uint8Array(ciphertext_buffer);
    var iv_and_ciphertext = new Uint8Array(iv.length + ciphertext.length);
    iv_and_ciphertext.set(iv, 0);
    iv_and_ciphertext.set(ciphertext, iv.length);
    return hex_encode(iv_and_ciphertext);
  }
  
  async aes_gcm_decrypt(ciphertext_hex, rawKey) {
    const canisterActor = await this.getVetkeysCanister(mailAddressDomain());

    const iv_and_ciphertext = hex_decode(ciphertext_hex);
    const iv = iv_and_ciphertext.subarray(0, 12); // 96-bits; unique per message
    const ciphertext = iv_and_ciphertext.subarray(12);
    const aes_key = await window.crypto.subtle.importKey("raw", rawKey, "AES-GCM", false, ["decrypt"]);
    let decrypted = await window.crypto.subtle.decrypt(
      { name: "AES-GCM", iv: iv },
      aes_key,
      ciphertext
    );
    return new TextDecoder().decode(decrypted);
  }
  

  async vetkd_derive_key() {
    const transportSecretKey = TransportSecretKey.random();
    const canisterActor = await this.getVetkeysCanister(mailAddressDomain());
    
    // unique `input` should be provided for each derived vetKey
    // we only need one vetKey in this example, so we choose to have the simplest possible `input` - an empty vector
    const input = new Uint8Array(0);
    // the called canister uses the caller's principal as part of `context` when calling the management canisters `vetkd_derive_key` endpoint under the hood (see code in Step 1)
    const encryptedVetKeyBytes = await canisterActor.vetkd_derive_key(transportSecretKey.publicKeyBytes(), input);
    const encryptedVetKey = EncryptedVetKey.deserialize(encryptedVetKeyBytes);

    const publicKeyBytes = await canisterActor.vetkd_public_key();
    const publicKey = DerivedPublicKey.deserialize(publicKeyBytes);
    // pass `input` from Step 2 to the verification function
    const vetKey = encryptedVetKey.decryptAndVerify(transportSecretKey, publicKey, input);

    return vetKey;
  }
  
  
  async get_aes_256_gcm_key() {
    const vetKey = await this.vetkd_derive_key();
    const bytes = vetKey.deriveSymmetricKey("crypton.plexisign.net", 32);
    return bytes;
  }
  
  async get_aes_256_gcm_key_in_hex() {
    const vetKey = await this.vetkd_derive_key();
    const bytes = vetKey.deriveSymmetricKey("crypton.plexisign.net", 32);
    const hex = hex_encode(bytes);
    return hex;
  }

  async requestWeb3Storage(did) {
    const canisterActor = await this.getCanisterForRequestingWeb3Storage(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }
    let storage = await canisterActor.requestWeb3Storage(did);
    if (!storage || storage.length === 0) {
        throw new Error('Failed to request storage');
    }
    storage = storage[0];
    if (!storage || storage.length === 0) {
        throw new Error('Failed to request storage');
    }
    storage = JSON.parse(storage);
    return storage.data;
  }
  
  // public shared ({ caller }) func addTestBill(type_: Text, action: Text, data: Text) : async (?En.Bill) 
  async addTestBill(type, action, data) {
    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }
    const bill = await canisterActor.addTestBill(type, action, data);
    return bill;
  }
  // public shared query ({ caller }) func getUserProfile() : async (?En.UserProfile) 
  async getUserProfile(withDefault=true) {
    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }
    const profile = await canisterActor.getUserProfile();
    if (!profile || profile.length === 0) {
        if (withDefault) {
            return {country: "", customerId:"", subscriptionId: "", subscriptionStatus: "", data: "", isTrail: true, mode: localStorage.getItem('app.payment-env') || 'prod'};
        }
        return null;
    }
    return profile[0];
  }

  async isActiveSubscribedUser() {
    let profile = await this.getUserProfile();
    if (!profile || profile.isTrail) {
        return true;
    }
    if (profile && profile.subscriptionStatus === 'active') {
        return true
    }
    return false;
  }

  // public shared ({ caller }) func sendVerificationSMS(address : Text, phone : Text) : async (Text)
  async sendVerificationSMS(phone) {
    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }
    const tx = await canisterActor.sendVerificationSMS(window.appConfig.recentActiveAccount, phone);
    return tx;
  }
  // public shared ({ caller }) func saveUserProfile(address: Text, tx: Text, verificationCode: Text, userProfile: En.UserProfile) : async (Bool) 
  async saveUserProfile(tx, verificationCode, userProfile) {
    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }
    if (localStorage.getItem('app.payment-env') === 'test') {
        userProfile.mode = 'test';
    } else {
        userProfile.mode = 'prod';
    }

    const result = await canisterActor.saveUserProfile(window.appConfig.recentActiveAccount, tx, verificationCode, userProfile);
    return result;
  }
  // public shared ({ caller }) func saveUserProfile(address: Text, tx: Text, verificationCode: Text, userProfile: En.UserProfile) : async (Bool) 
  async deleteUserProfile() {
    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }
    const result = await canisterActor.deleteUserProfile();
    return result;
  }


  detectLanguage() {
    const lang = navigator.language;
    // console.log("detectLanguage:", lang);
    if (lang.startsWith("zh")) {
      return "zh";
    } else if (lang.startsWith("en")) {
      return "en";
    } else if (lang.startsWith("es")) {
      return "es";
    } else {
      return "en";
    }
  }


  async createCustomerIfNeeded(name, email, phone, paymentMethodId) {
    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }
    const result = await canisterActor.createCustomerIfNeeded(name, email, phone, paymentMethodId);
    
    if (!result || result.length === 0) {
        throw new Error('Failed to create customer');
    }
    
    return result[0];
  }

  async queryCustomer() {
    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }
    const result = await canisterActor.queryCustomerOfMe();
    if (!result || result.length === 0) {
        throw new Error('Failed to query customer');
    }
    return JSON.parse(result);
  }

  async createSubscription() {
    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }
    const result = await canisterActor.createSubscription();
    if (!result || result.length === 0) {
        throw new Error('Failed to create subscription');
    }
    this.#clientSecure = null;
    return result[0];
  }

  async cancelSubscription() {
    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }
    const result = await canisterActor.cancelSubscription();
    if (!result || result.length === 0) {
        throw new Error('Failed to cancel subscription');
    }
    this.#clientSecure = null;
    return JSON.parse(result);
  }

  async retrieveSubscription() {
    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }
    const result = await canisterActor.retrieveSubscription();
    if (!result || result.length === 0) {
        throw new Error('Failed to retrieve subscription');
    }
    return JSON.parse(result);
  }

  async retrieveSubscriptionCheckoutSession() {
    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }

    let lang = localStorage.getItem("language");
    if (!lang || lang === "") {
        lang = this.detectLanguage();
    }

    if (lang !== "en" && lang !== "zh" && lang !== "es") {
        lang = "en";
    }

    const response = await canisterActor.retrieveSubscriptionCheckoutSession(lang);
    if (!response || response.length === 0) {
      return null;
    }
    return response[0];
  }
  async createSubscriptionCheckoutSession() {
    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }

    let lang = localStorage.getItem("language");
    if (!lang || lang === "") {
        lang = this.detectLanguage();
    }

    if (lang !== "en" && lang !== "zh" && lang !== "es") {
        lang = "en";
    }

    const response = await canisterActor.createSubscriptionCheckoutSession(lang);
    if (!response || response.length === 0) {
      return null;
    }
    this.#clientSecure = null;
    return response[0];
  }

  async checkSubscriptionCheckoutStatus() {
    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }
    const response = await canisterActor.checkSubscriptionCheckoutStatus();
    if (!response || response.length === 0) {
        return null;
    }
    return response[0];

  }

  async resetPaymentEnv() {
    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }
    const success = await canisterActor.resetPaymentEnv();
    return success;
  }
  base64DecodeSync(str, asString=true) {
    const buf = ethers.decodeBase64(str);
    if (asString) {
        const str = new TextDecoder().decode(buf);
        return str;
    }
    return buf;
  }

  isClientSecureValid(cs) {
    if(!cs) {
        return false;
    }
    const comps = cs.split('.');
    if (!comps || comps.length !== 3) {
        return false;
    }
    try {
        const payload = comps[1];
        const jwtPayload = this.base64DecodeSync(payload);
        const jwtPayloadObj = JSON.parse(jwtPayload);
        if (!jwtPayloadObj) {
            return false;
        }
        const exp = jwtPayloadObj.exp;
        if (!exp) {
            return false;
        }
        
        if (Date.now() > exp * 1000 - 300000) {
            return false;
        }
        return true;
    } catch (e) {
        console.error(e);
        return false;
    }
  }

  async getClientSecureDuringSignup() {
    let cs = this.#clientSecure;
    if (!cs) {
        cs = localStorage.getItem('app.cst')
    }
    if (this.isClientSecureValid(cs)) {
        return cs;
    }

    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix(), true);
    if (!canisterActor) {
        throw new Error('user not found');
    }
    const mode = localStorage.getItem('app.payment-env') || 'prod';
    const response = await canisterActor.getClientSecure(mode);
    if (response && response.length > 0) {
        this.#clientSecure = response;
        localStorage.setItem('app.cst', response);
        return this.#clientSecure;
    }
    return response;
  }

  async getClientSecure() {
    let cs = this.#clientSecure;
    if (!cs) {
        cs = localStorage.getItem('app.cst')
    }
    if (this.isClientSecureValid(cs)) {
        return cs;
    }

    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }
    const mode = localStorage.getItem('app.payment-env') || 'prod';
    const response = await canisterActor.getClientSecure(mode);
    if (response && response.length > 0) {
        this.#clientSecure = response;
        localStorage.setItem('app.cst', response);
        return this.#clientSecure;
    }
    return response;
  }
  
  async getSubscriberPendingUsageCounting() {
    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }
    const response = await canisterActor.getSubscriberPendingUsageCounting();
    return response;

  }
  async getPendingUsageCounting() {
    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }
    const response = await canisterActor.getPendingUsageCounting();
    return response;
  }
  async getTrailAccountBalance() {
    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }
    const response = await canisterActor.getAccountBalance();
    return response;
  }
  async getInvoicePreviewDirectly(subscriptionId) {
    let url = `${DIRECT_PAYMENT_SERVER_BASE_URL}/stripe/subscription/invoice-preview`;
    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        subscriptionId,
        country: "en",
      }),
    }).then(resp => {
        if (resp.status === 200) {
            return resp.json();
        }
        return {code: (resp.status > 0 ? -resp.status : resp.status), msg: resp.statusText};
    });

    console.log(resp);
    if (resp.code !== 0) {
        throw ServerError.from(resp);
    }
    const result = resp.data;
    return result;
  }

  async getUnpaidItems(cs) {
    const uc = await this.getPendingUsageCounting();
    if (cs.isTrailUser) {
        return {pending: uc, invoicePreview: null};
    }
    const invoicePreview = await this.getInvoicePreviewDirectly(cs.subscriptionId);
    return {pending: uc, invoicePreview};
  }
  cacheData(key, data) {
    this.#cache[key] = {
        expires_at: Date.now() + (15 * 60 * 1000),
        data: data,
    }
  } 
  getDataFromCache(key) {
    const v = this.#cache[key];
    if (v && v.expires_at && v.data) {
        if (v.expires_at > Date.now()) {
            return v.data;
        } else {
            this.clearCache(key);
        }
    }
    return null;
  }
  clearCache(key) {
    delete this.#cache[key];
  }
  clearAllCache() {
    this.#cache = {};
  }
  async getAllProductsDirectly(cs, lang="en", withCache=true) {
    const cacheKey = `products-${cs.country || "us"}-${lang}`;
    if (!this.forceRefresh && withCache) {
        const cachedData = this.getDataFromCache(cacheKey);
        if (cachedData) {
            return cachedData;
        }
    }

    const clientSecure = await this.getClientSecure();
    let url = `${DIRECT_PAYMENT_SERVER_BASE_URL}/stripe/product/list`;
    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + clientSecure
      },
      body: JSON.stringify({
        service: 'plexisign',
        country: cs.country || "us",
        lang: lang
      }),
    }).then(resp => {
        if (resp.status === 200) {
            return resp.json();
        }
        return {code: (resp.status > 0 ? -resp.status : resp.status), msg: resp.statusText};
    });

    console.log(resp);
    if (resp.code !== 0) {
        throw ServerError.from(resp);
    }
    const result = resp.data;
    // if (withCache) {
        this.cacheData(cacheKey, resp.data);
    // }
    return result;
  }

  async retrieveSubscriptionDirectly(cs, withCache=true) {

    const cacheKey = `subscription-${cs.country || "us"}-${cs.subscriptionId}`;
    if (!this.forceRefresh && withCache) {
        const cachedData = this.getDataFromCache(cacheKey);
        if (cachedData) {
            return cachedData;
        }
    }

    const clientSecure = await this.getClientSecure();

    let url = `${DIRECT_PAYMENT_SERVER_BASE_URL}/stripe/subscription/retrieve`;
    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + clientSecure
      },
      body: JSON.stringify({
        country: cs.country,
        subscriptionId: cs.subscriptionId
      }),
    }).then(resp => {
        if (resp.status === 200) {
            return resp.json();
        }
        return {code: (resp.status > 0 ? -resp.status : resp.status), msg: resp.statusText};
    });

    // if (withCache) {
        if (resp.code === 0) {
            this.cacheData(cacheKey, resp);
        }
    // }
    
    return resp;
    // console.log(resp);
    // if (resp.code !== 0) {
    //     throw ServerError.from(resp);
    // }
    // const result = resp.data;
    // return result;
  }

  async checkSubscriptionCheckoutStatusDirectly(sessionId) {
    const clientSecure = await this.getClientSecure();

    let url = `${DIRECT_PAYMENT_SERVER_BASE_URL}/stripe/subscription/checkout_status`;
    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + clientSecure
      },
      body: JSON.stringify({
        // country: cs.country,
        // subscriptionId: cs.subscriptionId
        sessionId: sessionId
      }),
    }).then(resp => {
        if (resp.status === 200) {
            return resp.json();
        }
        return {code: (resp.status > 0 ? -resp.status : resp.status), msg: resp.statusText};
    });

    console.log(resp);
    // if (resp.code !== 0) {
    //     throw ServerError.from(resp);
    // }
    // const result = resp.data;
    return resp;
  }

  async createCustomerPortalDirectly(cs, withCache=true) {
    const cacheKey = `customer_portal-${cs.country || "us"}-${cs.customerId}`;
    if (!this.forceRefresh && withCache) {
        const cachedData = this.getDataFromCache(cacheKey);
        if (cachedData) {
            return cachedData;
        }
    }
    const clientSecure = await this.getClientSecure();
    let url = `${DIRECT_PAYMENT_SERVER_BASE_URL}/stripe/customer/portal`;
    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + clientSecure
      },
      body: JSON.stringify({
        country: cs.country,
        customerId: cs.customerId
      }),
    }).then(resp => {
        if (resp.status === 200) {
            return resp.json();
        }
        return {code: (resp.status > 0 ? -resp.status : resp.status), msg: resp.statusText};
    });

    // if (withCache) {
        if (resp.code === 0) {
            this.cacheData(cacheKey, resp);
        }
    // }

    return resp;
    // console.log(resp);
    // if (resp.code !== 0) {
    //     throw ServerError.from(resp);
    // }
    // const result = resp.data;
    // return result;
  }

  async generateInvoicePreviewDirectly(cs, withCache=true) {
    const cacheKey = `invoice_preview-${cs.country || "us"}-${cs.subscriptionId}`;
    if (!this.forceRefresh && withCache) {
        const cachedData = this.getDataFromCache(cacheKey);
        if (cachedData) {
            return cachedData;
        }
    }
    const clientSecure = await this.getClientSecure();

    let url = `${DIRECT_PAYMENT_SERVER_BASE_URL}/stripe/subscription/invoice-preview`;
    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + clientSecure
      },
      body: JSON.stringify({
        country: cs.country,
        subscriptionId: cs.subscriptionId
      }),
    }).then(resp => {
        if (resp.status === 200) {
            return resp.json();
        }
        return {code: (resp.status > 0 ? -resp.status : resp.status), msg: resp.statusText};
    });

    // if (withCache) {
        if (resp.code === 0) {
            this.cacheData(cacheKey, resp);
        }
    // }
    return resp;
    // console.log(resp);
    // if (resp.code !== 0) {
    //     throw ServerError.from(resp);
    // }
    // const result = resp.data;
    // return result;
  }
  async getTotalBillAmountDirectly(cs, withCache=true) {
    const cacheKey = `total_bill-${cs.country || "us"}-${cs.subscriptionId}`;
    if (!this.forceRefresh && withCache) {
        const cachedData = this.getDataFromCache(cacheKey);
        if (cachedData) {
            return cachedData;
        }
    }
    const clientSecure = await this.getClientSecure();

    let url = `${DIRECT_PAYMENT_SERVER_BASE_URL}/stripe/invoice/total-amount`;
    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + clientSecure
      },
      body: JSON.stringify({
        country: cs.country,
        subscriptionId: cs.subscriptionId
      }),
    }).then(resp => {
        if (resp.status === 200) {
            return resp.json();
        }
        return {code: (resp.status > 0 ? -resp.status : resp.status), msg: resp.statusText};
    });

    console.log(resp);
    if (resp.code !== 0) {
        throw ServerError.from(resp);
    }
    const result = resp.data;
    
    // if (withCache) {
        this.cacheData(cacheKey, resp.data);
    // }
    return result;
  }


  calculateTotalAmount(product, start, usage) {
    // let productName = product.name;
    
    if (usage === 0) {
        const price = (product.tiers[0].unit_amount * 0.01).toFixed(2);
        return {
        total: 0,
        lines: [
            {
            description: `0 × ${product.name} (${PaymentStrings.tier} 1 ${PaymentStrings.at} ${price} / ${PaymentStrings.unit})`,
            pricing: {
                unit_amount_decimal: product.tiers[0].unit_amount,
            },
            quantity: 0,
            amount: 0,
            }
        ]
        };
    }

    let total = start + usage;
    if (total < 50) {
        const price = (product.tiers[0].unit_amount * 0.01).toFixed(2);
        const total_amount = usage * product.tiers[0].unit_amount
        return {
        total: total_amount,
        lines: [
            {
            description: `${usage} × ${product.name} (${PaymentStrings.tier} 1 ${PaymentStrings.at} ${price} / ${PaymentStrings.unit})`,
            pricing: {
                unit_amount_decimal: product.tiers[0].unit_amount,
            },
            quantity: usage,
            amount: total_amount,
            }
        ]
        };
    };

    let t1 = start < 50 ? 50 - start : 0;
    let t2 = usage - t1;

    let tire1 = t1 * product.tiers[0].unit_amount;
    let tire2 = t2 * product.tiers[1].unit_amount;
    
    const tire1Price = (product.tiers[0].unit_amount * 0.01).toFixed(2);
    const tire2Price = (product.tiers[1].unit_amount * 0.01).toFixed(2);
    if (t1 === 0) {
        return {
        total: tire1 + tire2,
        lines: [{
            description: `${t2} × ${product.name} (${PaymentStrings.tier} 2 ${PaymentStrings.at} ${tire2Price} / ${PaymentStrings.unit})`,
            pricing: {
                unit_amount_decimal: product.tiers[1].unit_amount,
            },
            quantity: t2,
            amount: tire2,
        }]
        };
    }

    return {
        total: tire1 + tire2,
        lines: [
        {
            description: `${t1} × ${product.name} (${PaymentStrings.tier} 1 ${PaymentStrings.at} ${tire1Price} / ${PaymentStrings.unit})`,
            pricing: {
                unit_amount_decimal: product.tiers[0].unit_amount,
            },
            quantity: t1,
            amount: tire1,
        },
        {
            description: `${t2} × ${product.name} (${PaymentStrings.tier} 2 ${PaymentStrings.at} ${tire2Price} / ${PaymentStrings.unit})`,
            pricing: {
                unit_amount_decimal: product.tiers[1].unit_amount,
            },
            quantity: t2,
            amount: tire2,
        }
    ]};
  }

  async calAccountBalance(cs, totalBillAmount) {
    const products = await this.getAllProductsDirectly(cs, this.detectLanguage());
    const invoicePreview = totalBillAmount.invoice;
    const usageCounting = await this.getSubscriberPendingUsageCounting(cs);



    const email_product = products.filter((product) => product.pid === "email")[0];
    const sms_product = products.filter((product) => product.pid === "sms")[0];
    const contract_product = products.filter((product) => product.pid === "contract")[0];
    const bridge_product = products.filter((product) => product.pid === "bridge")[0];

    const invoice_lines = invoicePreview.lines.data;
    const email_lines = invoice_lines.filter(line => line.price.product === email_product.id);
    const sms_lines = invoice_lines.filter(line => line.price.product === sms_product.id);
    const bridge_lines = invoice_lines.filter(line => line.price.product === bridge_product.id);
    const contract_lines = invoice_lines.filter(line => line.price.product === contract_product.id);

    const email_quantity = email_lines.reduce((accumulator, line) => accumulator + line.quantity, 0);
    const sms_quantity = sms_lines.reduce((accumulator, line) => accumulator + line.quantity, 0);
    const bridge_quantity = bridge_lines.reduce((accumulator, line) => accumulator + line.quantity, 0);
    const contract_quantity = contract_lines.reduce((accumulator, line) => accumulator + line.quantity, 0);

    const pendingEmailAmount = this.calculateTotalAmount(email_product, email_quantity, usageCounting.data.email_sent);
    const pendingSmsAmount = this.calculateTotalAmount(sms_product, sms_quantity, usageCounting.data.sms_sent);
    const pendingBridgeAmount = this.calculateTotalAmount(bridge_product, bridge_quantity, usageCounting.data.bridge_sent);
    const pendingContractAmount = this.calculateTotalAmount(contract_product, contract_quantity, usageCounting.data.contract_created);
    // return {
    //     total: pendingEmailAmount.total + pendingSmsAmount.total + pendingContractAmount.total,
    //     lines: [...pendingEmailAmount.lines, ...pendingSmsAmount.lines, ...pendingContractAmount.lines],
    // };
    return pendingEmailAmount.total + pendingSmsAmount.total + pendingBridgeAmount.total + pendingContractAmount.total + totalBillAmount.amount_remaining
  }

  async getAccountBalance(cs) {
    if (cs && cs.subscriptionId) {
        const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
        if (!canisterActor) {
            throw new Error('user not found');
        }
        let amount = await canisterActor.getAccountBalance();
        if (amount > 0) {
            return {isTrail: true, amount: amount};
        }
        
        const res = await this.getTotalBillAmountDirectly(cs);
        const total = await this.calAccountBalance(cs, res);
        // return {isTrail: false, amount: res.amount_remaining};
        return {isTrail: false, amount: total}
    }

    if (cs && cs.isTrail) {
        const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
        if (!canisterActor) {
            throw new Error('user not found');
        }
        let amount = await canisterActor.getAccountBalance();
        // const amount = await this.getAccountBalance();
        return {isTrail: true, amount: amount};
    }

    if (cs && !cs.isTrail) {
        const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
        if (!canisterActor) {
            throw new Error('user not found');
        }
        let amount = await canisterActor.getAccountBalance();
        return {isTrail: true, amount: amount};        
    }
    return {isTrail: false, amount: 0};
  } 

  async getUsageCounting(cs) {
    // if (cs && cs.subscriptionId) {
    //     return null;
    // };

    const canisterActor = await this.getCanisterByMailAddress(window.appConfig.recentActiveAccount + mailAddressSuffix());
    if (!canisterActor) {
        throw new Error('user not found');
    }
    const result = await canisterActor.getUsageCounting();
    result.code = Number(result.code);
    if (result.code !== 0) {
        throw new Error('Failed to retreive pending usage counting');
    }
    return result.data;
  };


  async getSignUpLogs(day) {
    const logs = await this.#indexClient.indexCanisterActor.getSignUpLogs(day);
    return logs;
  }

  async getSignUpStatisticV2(type="1") {
    const days = (type === "1") ? DateUtils.getLast7DaysDesc() : DateUtils.getLast30DaysDesc();
    
    const result = await this.#indexClient.indexCanisterActor.getSignUpStatisticV2(days);
    if (!result || result.length === 0) {
        return [];
    }

    return result.map(obj => {
        obj.count = Number(obj.count)
        return obj;
    }).filter(obj => obj.count > 0);
  }
} 